import scenarioImages from '../scenarioImages'

export default {
  slug: 'cx005',
  title: 'CX005',
  i18nKey: 'AutomotiveGnssProducts.cx005',
  heroTitleSize: 'large',
  images: {
    hero: require('@/assets/images/pixso-automotive-detail/cx005-hero.png'),
    description: require('@/assets/images/pixso-automotive-detail/cx005-description.jpg'),
    feature: require('@/assets/images/pixso-automotive-detail/cx005-feature.jpg')
  },
  descriptionTags: [
    { key: 'interface', image: require('@/assets/images/pixso-automotive-detail/icon-interface.svg') },
    { key: 'gnss', image: require('@/assets/images/pixso-automotive-detail/icon-gnss.svg') },
    { key: 'rtk', image: require('@/assets/images/pixso-automotive-detail/icon-rtk.svg') }
  ],
  featureTags: [
    { key: 'certification', image: require('@/assets/images/pixso-automotive-detail/icon-certification.svg') },
    { key: 'rfBaseband', image: require('@/assets/images/pixso-automotive-detail/icon-rf-baseband.svg') },
    { key: 'positioningEngine', image: require('@/assets/images/pixso-automotive-detail/icon-accuracy.svg') },
    { key: 'lowPower', image: require('@/assets/images/pixso-automotive-detail/icon-low-power.svg') },
    { key: 'gnss', image: require('@/assets/images/pixso-automotive-detail/icon-gnss.svg') }
  ],
  scenarios: [
    {
      key: 'tunnelFork',
      image: scenarioImages.tunnelFork
    },
    {
      key: 'parking',
      image: scenarioImages.parking
    },
    {
      key: 'overpass',
      image: scenarioImages.overpass
    },
    {
      key: 'urbanCanyon',
      image: scenarioImages.urbanCanyon
    },
    {
      key: 'complexTraffic',
      image: scenarioImages.complexTraffic
    },
    {
      key: 'treeLinedStreet',
      image: scenarioImages.treeLinedStreet
    }
  ],
  specTabs: []
}
